<template>
	<div>
		<el-dialog
			:title="title"
			:visible.sync="dialogFormVisible"
			:close-on-click-modal="false"
			width="600px"
			@close="submitTap('1')"
			:before-close="handleClose"
		>
		  <el-form :model="form" :rules="rules" ref="petForm" style="width:500px;" v-loading="loading">
				<el-form-item label="头像:" :label-width="formLabelWidth">
					<el-upload
						class="avatar-uploader"
						:action="$config.upload_img_url"
						:show-file-list="false"
						:on-success="handleAvatarSuccess"
						:before-upload="beforeAvatarUpload"
						accept="image/*"
					>
						<img v-if="form.pet_avatar" :src="$config.img_url+form.pet_avatar" class="avatar">
						<i v-else class="el-icon-plus avatar-uploader-icon"></i>
					</el-upload>
				</el-form-item>
			    <el-form-item label="宠物类型:" prop="pet_type" :label-width="formLabelWidth">
				  <el-radio-group v-model="form.pet_type" @change="petTypeChange">
					  <el-radio label="dog">狗狗</el-radio>
					  <el-radio label="cat" >猫咪</el-radio>
					  <el-radio label="other">其他</el-radio>
				  </el-radio-group>
			    </el-form-item>
			    <el-form-item label="宠物性别:" :label-width="formLabelWidth">
				  <el-radio-group v-model="form.pet_sex">
					  <el-radio label="0">公</el-radio>
					  <el-radio label="1">母</el-radio>
				  </el-radio-group>
			    </el-form-item>
				<el-form-item label="宠物昵称:" prop="pet_nickname" :label-width="formLabelWidth">
					<el-input v-model="form.pet_nickname" placeholder="请输入宠物昵称" autocomplete="off"></el-input>
				</el-form-item>
				<el-form-item label="宠物品种:" :label-width="formLabelWidth">
					<el-select v-model="form.pet_breed_id" filterable placeholder="请选择宠物品种" style="width:100%;">
						<el-option
							v-for="type in petsTypeList"
							:key="type.pet_breed_id"
						 	:label="type.pet_breed_name"
							:value="type.pet_breed_id"
						></el-option>
					</el-select>
				</el-form-item>
			    <el-form-item label="宠物生日:" :label-width="formLabelWidth">
					  <el-date-picker
							v-model="form.pet_birthday"
							value-format="yyyy-MM-dd"
							type="date"
							style="width:100%;"
							placeholder="请设置生日"
						>
					  </el-date-picker>
				</el-form-item>
				<el-form-item label="档案号:" :label-width="formLabelWidth">
					<el-input v-model="form.pet_file_number" placeholder="请输入档案号" autocomplete="off"></el-input>
				</el-form-item>
				<el-form-item label="宠物毛色:" :label-width="formLabelWidth">
					<el-input v-model="form.pet_color" placeholder="请输入宠物毛色" autocomplete="off"></el-input>
				</el-form-item>
				<!-- <el-form-item label="宠物年龄:" :label-width="formLabelWidth">
				<el-input v-model="form.pet_age" placeholder="请输入宠物年龄" autocomplete="off"></el-input>
				</el-form-item>
				<el-form-item label="宠物长短毛:" :label-width="formLabelWidth">
				  <el-radio-group v-model="form.pet_fur">
					  <el-radio :label="1" value="long">长毛</el-radio>
					  <el-radio :label="2" value="short" >短毛</el-radio>
					  <el-radio :label="3" value="other">其他</el-radio>
				  </el-radio-group>
				</el-form-item> -->
				<el-form-item label="宠物体重:" :label-width="formLabelWidth">
					<el-input v-model="form.pet_weight" placeholder="请输入宠物体重" autocomplete="off">
						<template slot="append">KG</template>
					</el-input>
				</el-form-item>
				<el-form-item label="宠物身高:" :label-width="formLabelWidth">
					<el-input v-model="form.pet_height" placeholder="请输入宠物身高" autocomplete="off">
						<template slot="append">CM</template>
					</el-input>
				</el-form-item>
				<el-form-item label="是否绝育:" :label-width="formLabelWidth">
					<el-radio-group v-model="form.pet_sterilization">
						<el-radio label="1">已绝育</el-radio>
						<el-radio label="0">未绝育</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="是否疫苗:" :label-width="formLabelWidth">
					<el-radio-group v-model="form.pet_vaccine">
						<el-radio label="1">已疫苗</el-radio>
						<el-radio label="0">未疫苗</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="备注:" :label-width="formLabelWidth">
					<el-input type="textarea" v-model="form.remake" placeholder="请输入备注" style="height:50px;"></el-input>
				</el-form-item>
		  </el-form>
		  <div slot="footer" class="dialog-footer">
		    <el-button @click="submitTap('1')">取 消</el-button>
		    <el-button type="FF7" @click="submitTap('2','petForm')">保 存</el-button>
		  </div>
		</el-dialog>
	</div>
</template>

<script>
import { resetInsertData } from '@/common/js/util';

	export default {
		name:'addPet',
		props:{
			status: {
				type: Boolean,
				default: false
			},
			userId:{
				type: [Number, String],
				default: 0,
			},
			petId:{
				type: [Number, String],
				default: 0,
			}
		},
		data() {
		  return {
				loading: false,
				dialogFormVisible:false,
				pet_avatar_url:'', //头像
				title:'新增宠物档案',
				pet_id: 0,
				user_id: 0,
				form: {
					pet_type: '',
					pet_sex: '',
					pet_nickname: '',
					pet_avatar: '',
					pet_breed_id: '',
					pet_birthday: '',
					pet_file_number: '',
					pet_color: '',
					pet_weight: '',
					pet_height: '',
					pet_sterilization: '',
					pet_vaccine: '',
					remake: ''
				},
				formLabelWidth: '120px',
				rules: {
					pet_type: [
						{ required: true, message: '请选择宠物类型', trigger: 'select' }
					],
					pet_nickname: [
						{ required: true, message: '请输入宠物昵称', trigger: 'blur' }
					]
				},
				petsTypeList: [],
				imageUrl: ''
		  };
		},
		computed:{
			readyToFetch() {
				return Boolean(this.dialogFormVisible && this.pet_id && this.user_id);
			},
		},
		watch:{
			status(val){
				 this.dialogFormVisible = val;
				
			},
			petId(newVal){
				this.pet_id = newVal
				if (newVal > 0) {
					this.title = '编辑宠物档案';
				}else {
					this.title = '新增宠物档案';
				}
			},
			userId(newVal){
 				this.user_id = newVal
			},
			readyToFetch(newVal){
				if (newVal){
					this.initDetail()
				}
			},
			dialogFormVisible(newVal,oldVal) {
				if ((newVal != oldVal) && newVal) {
					this.initPetBreedList()
				}
			}
		},
		methods:{
			// 获取宠物品种列表
			initPetBreedList() {
				this.$ajax({
					method : 'com.get.merchant_user.pet.breed_list',
					data : {
						pet_type : this.form.pet_type
					}
				}).then(res => {
					if (res.status = 10000) {
						this.petsTypeList = res.data.list;
						// this.gradeList[0] ? this.form.group_id = this.gradeList[0].group_id : '';
					}
				})
			},
			//当选择物种后，动态获取品种数据
			petTypeChange () {
				this.form.pet_breed_id = '';
				this.initPetBreedList();
			},
			// 获取宠物详情
			initDetail() {
				this.loading = true;
				this.$ajax({
					method : 'com.get.merchant_user.pet.info',
					data : { 
						user_id: this.user_id,
						pet_id: this.pet_id
					}
				}).then(res => {
					if (res.status == 10000) {
						this.form = res.data.info;
						this.form.pet_breed_id = this.form.pet_breed_id == 0 ? '' : this.form.pet_breed_id;
						this.form.pet_height = this.form.pet_height == 0 ? '' : this.form.pet_height;
						this.form.pet_weight = this.form.pet_weight == 0 ? '' : this.form.pet_weight;
					} else {
						this.$message.error(res.info);
					}
					this.loading = false;
				})
			},
			submitTap(type,obj) {
				if(type == '2'){
					this.submitForm(obj);
				} else {
					this.$emit('add',false,'cancel')
					resetInsertData(this, ['form','pet_id', 'imageUrl'], true)
				}
				
			},
			// 新增和删除宠物表单
			submitForm(formName) {
				this.$refs[formName].validate((valid) => {
				  if (valid) {
						const { pet_id, user_id, form } = this

						if (!this.form.pet_birthday) {
							this.form.pet_birthday = ''
						}
						const postData = {
							method: `com.set.merchant_user.pet.${ pet_id > 0 ? 'update':'save'}`,
							data : {
								user_id,
								...form,
								...(pet_id > 0 ? { pet_id } : {}),
							}
						}
						this.$ajax(postData).then(res => {
							if (res.status == 10000) {
								this.messages(pet_id ? '编辑成功' : '新增成功','success');
								this.$emit('add', false, 'save');
								resetInsertData(this, ['form','pet_id', 'imageUrl'], true)
								// this.dialogFormVisible = false;
							} else {
								this.$message.error(res.info);
							}
						})
				  } else {
						return false;
				  }
				});
			},
			// 图片上传成功回调
			handleAvatarSuccess(res, file) {
				const response = JSON.parse(res.response);
				if (response.status == 10000) {
					// this.imageUrl = URL.createObjectURL(file.raw);
					this.form.pet_avatar = response.data.list[0].file_path;
				} else {
					this.$message.error(response.info);
				}
			},
			// 上传前
			beforeAvatarUpload(file) {
				const isLt2M = file.size / 1024 / 1024 < 2;
				if (!isLt2M) {
					this.$message.error('上传头像图片大小不能超过 2MB!');
				}
				return isLt2M;
			},
			// 关闭表单时清除表单数据
			handleClose(done) {
				resetInsertData(this, ['form','pet_id'], true)
				done();
			}
		}
	}

</script>

<style scoped lang="scss">
	@import '~scss_vars';
	.search_user_box{height:70px;}
	.pa_main_add_btn{font-size:16px;margin-top:18px;line-height:24px;font-weight:'bold';background:#fff;color:#999;text-align:center;}
	.pa_main_status_box{display:flex;}
	.pa_main_status_box .cols{width:16.6%;margin-left:10px;height:70px;padding:14px 0;color:#fff;border-radius:10px;text-align:center;}
	.pa_main_status_box .cols .numbers{font-size:34px;}
	
	.pa_main_search_inner{display:flex;padding:18px 0;}
	
	.pa_user_info_box{
		background:#fff;border-radius:10px;
		.img{
			width:60px;height:60px;border-radius:50%;
		}
		.text{
			padding:0 0 0 10px;
			.labels{display:block;width:40px;line-height:18px;margin-top:5px;background:#FF700B;text-align:center;color:#fff;font-size:12px;border-radius:6px;}
		}
		.el-icon-arrow-right{position:absolute;right:0;font-size:20px;}
		.over,.card{
			width:50%;text-align:center;
			span{display:block;margin-bottom:5px;font-size:18px;}
		}
		.pa_btn{margin-left:0;}
	}
</style>


// WEBPACK FOOTER //
// addPet.vue?764fc44c